const attachmentFilesEquipmentModelsTypo = {
  label: 'Equipment Type Attachments',
  noResults: 'No results found'
};

export default attachmentFilesEquipmentModelsTypo;
